export default {
    art: [
        {
            src: require('../assets/img/allubumItem/art/IMG_7032.webp')
        },
        {
            src: require('../assets/img/allubumItem/art/IMG_7033.webp')
        },
        {
            src: require('../assets/img/allubumItem/art/IMG_7034.webp')
        },

    ],
    audiovisual: [
        {
            src: require('../assets/img/allubumItem/audiovisual/IMG_6969.webp')
        },
        {
            src: require('../assets/img/allubumItem/audiovisual/IMG_6968.webp')
        },
    ],
    base: [
        {
            src: require('../assets/img/allubumItem/base/IMG_7210.webp')
        },
        {
            src: require('../assets/img/allubumItem/base/IMG_7213.webp')
        },
        {
            src: require('../assets/img/allubumItem/base/IMG_7215.webp')
        }
    ],
    broadcast: [
        {
            src: require('../assets/img/allubumItem/broadcast/IMG_7503.webp')
        },
        {
            src: require('../assets/img/allubumItem/broadcast/IMG_7498.webp')
        },
    ],
    classRoom: [
        {
            src: require('../assets/img/allubumItem/classRoom/IMG_7039.webp')
        },
        {
            src: require('../assets/img/allubumItem/classRoom/IMG_7469.webp')
        },
    ],
    clothing: [
        {
            src: require('../assets/img/allubumItem/clothing/IMG_6900.webp')
        },
        {
            src: require('../assets/img/allubumItem/clothing/IMG_6902.webp')
        },
        {
            src: require('../assets/img/allubumItem/clothing/IMG_6904.webp')
        },
    ],
    computer: [
        {
            src: require('../assets/img/allubumItem/computer/IMG_6932.webp')
        },
        {
            src: require('../assets/img/allubumItem/computer/IMG_6931.webp')
        },
    ],
    corridor: [
        {
            src: require('../assets/img/allubumItem/corridor/IMG_7019.webp')
        },
        {
            src: require('../assets/img/allubumItem/corridor/IMG_7066.webp')
        },
        {
            src: require('../assets/img/allubumItem/corridor/IMG_7068.webp')
        },
        {
            src: require('../assets/img/allubumItem/corridor/IMG_7109.webp')
        },

    ],
    council: [
        {
            src: require('../assets/img/allubumItem/council/IMG_6953.webp')
        },
        {
            src: require('../assets/img/allubumItem/council/IMG_6955.webp')
        },

    ],
    councilHed: [
        {
            src: require('../assets/img/allubumItem/councilHed/IMG_6950.webp')
        },
        {
            src: require('../assets/img/allubumItem/councilHed/IMG_6948.webp')
        }
    ],
    elevator: [
        {
            src: require('../assets/img/allubumItem/elevator/IMG_6909.webp')
        },
        {
            src: require('../assets/img/allubumItem/elevator/IMG_6911.webp')
        },
        {
            src: require('../assets/img/allubumItem/elevator/IMG_6913.webp')
        },

    ],
    English: [
        {
            src: require('../assets/img/allubumItem/English/IMG_6992.webp')
        },
        {
            src: require('../assets/img/allubumItem/English/IMG_6994.webp')
        },
        {
            src: require('../assets/img/allubumItem/English/IMG_6996.webp')
        },

    ],
    etc: [
        {
            src: require('../assets/img/allubumItem/etc/IMG_6925.webp')
        },
        {
            src: require('../assets/img/allubumItem/etc/IMG_7111.webp')
        },
        {
            src: require('../assets/img/allubumItem/etc/IMG_7112.webp')
        },
        {
            src: require('../assets/img/allubumItem/etc/IMG_7186.webp')
        },
        {
            src: require('../assets/img/allubumItem/etc/IMG_7188.webp')
        },
        {
            src: require('../assets/img/allubumItem/etc/IMG_6562.webp')
        },
    ],
    ground: [
        {
            src: require('../assets/img/allubumItem/ground/IMG_7201.webp')
        },
        {
            src: require('../assets/img/allubumItem/ground/IMG_7204.webp')
        },
        {
            src: require('../assets/img/allubumItem/ground/IMG_7209.webp')
        },
        {
            src: require('../assets/img/allubumItem/ground/IMG_7229.webp')
        },
        {
            src: require('../assets/img/allubumItem/ground/IMG_7231.webp')
        },
        {
            src: require('../assets/img/allubumItem/ground/IMG_7233.webp')
        },
        {
            src: require('../assets/img/allubumItem/ground/IMG_7235.webp')
        },
    ],
    gym: [
        {
            src: require('../assets/img/allubumItem/gym/IMG_7073.webp')
        },
        {
            src: require('../assets/img/allubumItem/gym/IMG_7076.webp')
        },
        {
            src: require('../assets/img/allubumItem/gym/IMG_7078.webp')
        },
        {
            src: require('../assets/img/allubumItem/gym/IMG_7083.webp')
        },
    ],
    infirmary: [
        {
            src: require('../assets/img/allubumItem/infirmary/IMG_7491.webp')
        },
        {
            src: require('../assets/img/allubumItem/infirmary/IMG_7492.webp')
        },
        {
            src: require('../assets/img/allubumItem/infirmary/IMG_7493.webp')
        },
    ],
    kitchenRoom: [
        {
            src: require('../assets/img/allubumItem/kitchenRoom/IMG_7101.webp')
        },
        {
            src: require('../assets/img/allubumItem/kitchenRoom/IMG_7100.webp')
        },
        {
            src: require('../assets/img/allubumItem/kitchenRoom/IMG_7102.webp')
        },
    ],
    lerning: [
        {
            src: require('../assets/img/allubumItem/lerning/IMG_6887.webp')
        },
        {
            src: require('../assets/img/allubumItem/lerning/IMG_6890.webp')
        },

    ],
    library: [
        {
            src: require('../assets/img/allubumItem/library/IMG_7012.webp')
        },
        {
            src: require('../assets/img/allubumItem/library/IMG_7014.webp')
        },
        {
            src: require('../assets/img/allubumItem/library/IMG_7015.webp')
        },
        {
            src: require('../assets/img/allubumItem/library/IMG_7017.webp')
        },
    ],
    martialArts: [
        {
            src: require('../assets/img/allubumItem/martialArts/IMG_7106.webp')
        },
        {
            src: require('../assets/img/allubumItem/martialArts/IMG_7105.webp')
        },
        {
            src: require('../assets/img/allubumItem/martialArts/IMG_7107.webp')
        },

    ],
    multipurposeClass: [
        {
            src: require('../assets/img/allubumItem/multipurposeClass/IMG_6964.webp')
        },
        {
            src: require('../assets/img/allubumItem/multipurposeClass/IMG_6961.webp')
        },
        {
            src: require('../assets/img/allubumItem/multipurposeClass/IMG_6963.webp')
        },
    ],
    multipurposeHole1: [
        {
            src: require('../assets/img/allubumItem/multipurposeHole1/IMG_6941.webp')
        },
        {
            src: require('../assets/img/allubumItem/multipurposeHole1/IMG_6945.webp')
        },
        {
            src: require('../assets/img/allubumItem/multipurposeHole1/IMG_6944.webp')
        },
    ],
    multipurposeHole2: [
        {
            src: require('../assets/img/allubumItem/multipurposeHole2/IMG_7001.webp')
        },
        {
            src: require('../assets/img/allubumItem/multipurposeHole2/IMG_7003.webp')
        },
    ],
    multipurposeHole3: [
        {
            src: require('../assets/img/allubumItem/multipurposeHole3/IMG_7051.webp')
        },
        {
            src: require('../assets/img/allubumItem/multipurposeHole3/IMG_7053.webp')
        },
        {
            src: require('../assets/img/allubumItem/multipurposeHole3/IMG_7055.webp')
        },
    ],
    music1: [
        {
            src: require('../assets/img/allubumItem/music1/IMG_7057.webp')
        },
        {
            src: require('../assets/img/allubumItem/music1/IMG_7479.webp')
        },
    ],
    music2: [
        {
            src: require('../assets/img/allubumItem/music2/IMG_7485.webp')
        },
        {
            src: require('../assets/img/allubumItem/music2/IMG_7486.webp')
        },
    ],
    nagomi: [
        {
            src: require('../assets/img/allubumItem/nagomi/IMG_6883.webp')
        },
        {
            src: require('../assets/img/allubumItem/nagomi/IMG_6884.webp')
        },
    ],
    parking: [
        {
            src: require('../assets/img/allubumItem/parking/IMG_7195.webp')
        },
        {
            src: require('../assets/img/allubumItem/parking/IMG_7255.webp')
        },
        {
            src: require('../assets/img/allubumItem/parking/IMG_7256.webp')
        },
    ],
    science1: [
        {
            src: require('../assets/img/allubumItem/science1/IMG_6988.webp')
        },
        {
            src: require('../assets/img/allubumItem/science1/IMG_6985.webp')
        },
        {
            src: require('../assets/img/allubumItem/science1/IMG_6986.webp')
        },
    ],
    science2: [
        {
            src: require('../assets/img/allubumItem/science2/IMG_6979.webp')
        },
        {
            src: require('../assets/img/allubumItem/science2/IMG_6977.webp')
        },
        {
            src: require('../assets/img/allubumItem/science2/IMG_6980.webp')
        },

        {
            src: require('../assets/img/allubumItem/science2/IMG_6981.webp')
        },
    ],
    soft: [
        {
            src: require('../assets/img/allubumItem/soft/IMG_7222.webp')
        },
        {
            src: require('../assets/img/allubumItem/soft/IMG_7228.webp')
        },
        {
            src: require('../assets/img/allubumItem/soft/IMG_7224.webp')
        },
        {
            src: require('../assets/img/allubumItem/soft/IMG_7227.webp')
        },
    ],
    stairs: [
        {
            src: require('../assets/img/allubumItem/stairs/IMG_6973.webp')
        },
        {
            src: require('../assets/img/allubumItem/stairs/IMG_7086.webp')
        },
    ],
    technical: [
        {
            src: require('../assets/img/allubumItem/technical/IMG_7092.webp')
        },
        {
            src: require('../assets/img/allubumItem/technical/IMG_7095.webp')
        },
        {
            src: require('../assets/img/allubumItem/technical/IMG_7096.webp')
        },
    ],
    tennis: [
        {
            src: require('../assets/img/allubumItem/tennis/IMG_7248.webp')
        },
        {
            src: require('../assets/img/allubumItem/tennis/IMG_7249.webp')
        },
        {
            src: require('../assets/img/allubumItem/tennis/IMG_7252.webp')
        },
    ],
    veranda: [
        {
            src: require('../assets/img/allubumItem/veranda/IMG_7490.webp')
        },
        {
            src: require('../assets/img/allubumItem/veranda/IMG_7041.webp')
        },
    ],
    circle: [
        {
            src: require('../assets/img/allubumItem/circle/c1.jpg')
        },
        {
            src: require('../assets/img/allubumItem/circle/c2.jpg')
        },
        {
            src: require('../assets/img/allubumItem/circle/c3.jpg')
        },
        {
            src: require('../assets/img/allubumItem/circle/c4.jpg')
        },
        {
            src: require('../assets/img/allubumItem/circle/c5.jpg')
        },
        {
            src: require('../assets/img/allubumItem/circle/c6.jpg')
        },
        {
            src: require('../assets/img/allubumItem/circle/c7.jpg')
        },
    ],
}
